var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DealListSort } from "@irati/types";
import client from "@irati/utils/services/apollo";
import { formatGeoDealsAndMarkers } from "@irati/geolocation/src/helpers/geoDeals";
import dealQuery from "./queries/deal";
import geoDealsQuery from "./queries/geoDeals";
import perksGoPromotionalDeals from "./queries/PerksGoPromotionalDeals";
import { getFetchPolicy } from "../helpers/apollo/fetchPolicy";
import dealListQuery, { dealListQueryKey } from "./queries/dealList";
// ? copy / paste from legacy deal service - not sure if its still needed
function hack(_a) {
    var _b;
    var userSavings = _a.savings.userSavings;
    userSavings.value = (_b = userSavings.value) !== null && _b !== void 0 ? _b : null;
}
var DealsService = /** @class */ (function () {
    function DealsService() {
    }
    DealsService.prototype.deal = function (variables, options) {
        if (options === void 0) { options = {}; }
        return client.query(__assign(__assign({}, options), { query: dealQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            hack(data.deal);
            return data.deal;
        });
    };
    DealsService.prototype.list = function (variables, options) {
        if (options === void 0) { options = {}; }
        return client.query(__assign(__assign({}, options), { query: dealListQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[dealListQueryKey];
        });
    };
    DealsService.prototype.geoDeals = function (boundingBox, forceRefetch, limit) {
        if (forceRefetch === void 0) { forceRefetch = false; }
        if (limit === void 0) { limit = 50; }
        var variables = {
            q: "",
            geo: 1,
            slim: 1,
            limit: limit,
            insideBoundingBox: boundingBox.join(",")
        };
        return client.query({ query: geoDealsQuery, fetchPolicy: getFetchPolicy(forceRefetch), variables: variables }).then(function (_a) {
            var data = _a.data;
            var results = data.geoDeals.results;
            var _b = formatGeoDealsAndMarkers(results), geoDeals = _b.geoDeals, geoMarkers = _b.geoMarkers;
            return { geoDeals: geoDeals, geoMarkers: geoMarkers };
        });
    };
    DealsService.prototype.perksGoPromotionalDeals = function (_a, options) {
        var _b = _a === void 0 ? {} : _a, _c = _b.limit, limit = _c === void 0 ? 10 : _c, _d = _b.sort, sort = _d === void 0 ? DealListSort.Date : _d;
        if (options === void 0) { options = {}; }
        var variables = {
            sort: sort,
            limit: limit
        };
        return client.query(__assign(__assign({}, options), { query: perksGoPromotionalDeals, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data.perksGoPromotionalDeals.results;
        });
    };
    return DealsService;
}());
var service = new DealsService();
export default service;
